import AnchorPointLayer from './AnchorPointLayer';
import { MapLegend } from '../../../../../../layout/layoutHeader/components';
import { inject, observer } from 'mobx-react';
import { legendItems } from './constants';
import { getAnchorPointMarker } from './utils';

const ShowAnchorPoints = ({ theme, glEventHub, showNotification, refreshData, IBPlanningStore }) => {
  return (
    <>
      {IBPlanningStore.routeMapControls.isToggleAnchorPointsEnabled && (
        <AnchorPointLayer
          glEventHub={glEventHub}
          showNotification={showNotification}
          refreshData={refreshData}
          selectedRoutesAnchorPointList={IBPlanningStore.selectedRoutesAnchorPointList || []}
        />
      )}
      <MapLegend
        isEnabled={IBPlanningStore.routeMapControls.isMapLegendEnabled}
        renderIcon={({ item, theme }) => getAnchorPointMarker({
          anchorPointData: item.data,
          theme,
          isActiveAnchorPoint: item.isActive,
          isDisabledAnchorPoint: item.isDisabled,
          ...item
        })}
        legendItems={legendItems(theme)}
      />
    </>
  );
};

export default inject('IBPlanningStore')(observer(ShowAnchorPoints));
